import { type PropsWithChildren, useEffect, useState } from "react";

const Mounted = ({ children }: PropsWithChildren<{}>) => {
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	if (!mounted) {
		return null;
	}

	return <>{children}</>;
};

export default Mounted;
